import catalogModule from '../catalogModule';

function thumbnailService($log, $q, httpService, catalogConstants) {
    "ngInject";

    return {
        getItemThumbnails: function (type, dataMapKey, thumbnailParams) {
            const { itemTypes, thumbnailValidationStatus, thumbnailValidationClasses } = catalogConstants;
            const params = {
                size: thumbnailParams.size
            }
            const itemIds = [];
            for (const key in dataMapKey) {
                itemIds.push(dataMapKey[key].id);
            }

            let url;
            switch (type) {
                case itemTypes.bundle:
                    Object.assign(params, { bundleIds: itemIds });
                    url = catalogConstants.endpoints.getBundleThumbnails;
                    break;
                case itemTypes.asset:
                default:
                    Object.assign(params, { assetIds: itemIds });
                    url = catalogConstants.endpoints.getCatalogThumbnails;
                    break;
            }
            // TODO: need to check BE, might need batch request
            return httpService.httpGet(url, params)
                .then(function success(result) {
                    const returnResult = result && result.data ? result.data : [];
                    returnResult.forEach(function (item) {
                        const { targetId } = item;
                        item.key = dataMapKey[targetId].key;

                        switch (item.state) {
                            case thumbnailValidationStatus.error:
                                item.placeholderClass = thumbnailValidationClasses.error;
                                break;
                            case thumbnailValidationStatus.inReview:
                                item.placeholderClass = thumbnailValidationClasses.inReview;
                                break;
                            case thumbnailValidationStatus.pending:
                                item.placeholderClass = thumbnailValidationClasses.pending;
                                break;
                            case thumbnailValidationStatus.blocked:
                                item.placeholderClass = thumbnailValidationClasses.blocked;
                                break;
                            default:
                                item.placeholderClass = thumbnailValidationClasses.placeholder;
                                break;
                        }
                    });
                    return returnResult;
                });
        }
    }
}

catalogModule.factory("thumbnailService", thumbnailService);

export default thumbnailService;